export const auth0Config = {
  domain: process.env.REACT_APP_AUTH0_DOMAIN || "",
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID || "",
  cognitoIdentityPoolId:
    process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID || "",
  cognitoRegion: process.env.REACT_APP_AWS_COGNITO_REGION,
};
